import React from "react";
import { History } from "history";
import { Page } from "../..";
import { IParametrosSimulacao } from ".";
import {
  Alerta,
  Box,
  CampoTexto,
  Col,
  Row,
  Botao,
  TipoBotao,
  PosicaoTituloCampoTexto,
  TipoAlerta,
} from "@intechprev/componentes-web";
import {
  DadosPessoaisService,
  ContratoEmprestimoService,
} from "../../../services";
import { TokenService } from "../../../services/TokenService";

interface Props {
  history?: History;
}

interface State {
  dados: any;
  dadosSimulacao: IParametrosSimulacao;
  tokenRecebido: string;
  tokenDigitado: string;
}

export class EmprestimosSimuladorToken extends React.Component<Props, State> {
  private page = React.createRef<Page>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    const dados: IParametrosSimulacao = JSON.parse(
      localStorage.getItem("emprestimo-parametros")
    );

    this.state = {
      dados: null,
      dadosSimulacao: dados,
      tokenRecebido: "",
      tokenDigitado: "",
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);

    var dados = await DadosPessoaisService.Buscar();

    await this.setState({
      dados,
    });

    await this.page.current.loading(false);
  };

  enviarToken = async () => {
    var token = await TokenService.Gerar();

    await this.setState({
      tokenRecebido: token,
    });

    alert(
      "Um código de validação foi enviado para o seu e-mail cadastrado. Digite o código no campo abaixo. Caso não tenha recebido, verifique em sua caixa de spam ou entre em contato conosco."
    );
  };

  contratar = async () => {
    try {
      const parametros = {
        SqNatureza: this.state.dadosSimulacao.natureza.SQ_NATUREZA,
        SqPlanoPrevidencial: this.state.dadosSimulacao.plano
          .SQ_PLANO_PREVIDENCIAL,
        ValorSolicitado: this.state.dadosSimulacao.valorSolicitado,
        Tabela: this.state.dadosSimulacao.tabela,
        TabelaPrazo: this.state.dadosSimulacao.prestacao.Prazo,
        TabelaTaxa: Number(this.state.dadosSimulacao.prestacao.Taxa),
        TabelaValor: Number(this.state.dadosSimulacao.prestacao.Valor),
        ValorCorrecao: this.state.dadosSimulacao.valorCorrecao,
        ValorJurosAdicional: this.state.dadosSimulacao.valorJurosAdicional,
        Token: this.state.tokenRecebido,
        TokenDigitado: this.state.tokenDigitado,
      };

      var resultado = await ContratoEmprestimoService.Contratar(parametros);

      if (resultado.Resultado.mensagem) alert(resultado.Resultado.mensagem);

      this.props.history.push("/emprestimos");
    } catch (err) {
      alert(err.response ? err.response.data : err);
    }
  };

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        <h3>Bem-Vindo ao Simulador de Empréstimos da EQTPREV!</h3>
        <h5>
          Ao final da sua simulação você poderá realizar o requerimento do seu
          empréstimo diretamente por aqui, de forma on-line e segura!
        </h5>

        {this.state.dados && (
          <>
            <Row>
              <Col>
                <Box>
                  <p>
                    Para concluir a sua solicitação de empréstimo,{" "}
                    <b>
                      enviaremos um código de validação para o seu e-mail
                      cadastrado na EqtPrev.
                    </b>
                  </p>

                  <Botao
                    titulo={
                      this.state.tokenRecebido
                        ? "Reenviar código"
                        : "Enviar código"
                    }
                    onClick={this.enviarToken}
                    usaLoading
                    tipo={
                      this.state.tokenRecebido
                        ? TipoBotao.light
                        : TipoBotao.primary
                    }
                    className="mt-3 mb-3"
                  />

                  {this.state.tokenRecebido && (
                    <>
                      <CampoTexto
                        contexto={this}
                        nome={"tokenDigitado"}
                        titulo="Código Recebido"
                        posicaoTitulo={PosicaoTituloCampoTexto.cima}
                        max={6}
                        valor={this.state.tokenDigitado}
                      />

                      <Botao
                        titulo={"Requerer Empréstimo"}
                        onClick={this.contratar}
                        tipo={TipoBotao.secondary}
                        className="mt-3"
                        usaLoading
                      />
                      <br />

                      <Botao
                        titulo={"Voltar"}
                        onClick={() => this.props.history.goBack()}
                        tipo={TipoBotao.light}
                        className="mt-3"
                      />
                    </>
                  )}
                </Box>
              </Col>
              <Col>
                <Box titulo={"Dados Bancários para Crédito do Empréstimo"}>
                  {this.state.dados && (
                    <>
                      {!this.state.dados.CD_BANCO && (
                        <Box>
                          <Alerta
                            mensagem={
                              "Não encontramos seus dados bancários. Verifique seu cadastro junto à entidade"
                            }
                            tipo={TipoAlerta.danger}
                          />
                        </Box>
                      )}

                      {this.state.dados.CD_BANCO && (
                        <>
                          <CampoTexto
                            contexto={this}
                            nome={"Banco"}
                            titulo="Banco"
                            tamanhoTitulo={"lg-3"}
                            valor={
                              this.state.dados.CD_BANCO +
                              "-" +
                              this.state.dados.NO_BANCO
                            }
                            desabilitado
                          />
                          <CampoTexto
                            contexto={this}
                            nome={"Agencia"}
                            titulo="Agência"
                            tamanhoTitulo={"lg-3"}
                            valor={
                              this.state.dados.CD_AGENCIA +
                              "-" +
                              this.state.dados.DV_AGENCIA
                            }
                            desabilitado
                          />
                          <CampoTexto
                            contexto={this}
                            nome={"Conta"}
                            titulo="Conta"
                            tamanhoTitulo={"lg-3"}
                            valor={
                              this.state.dados.NR_CC +
                              "-" +
                              this.state.dados.DV_CC
                            }
                            desabilitado
                          />
                        </>
                      )}

                      <p className="mt-3">
                        Algo errado?
                        <Botao
                          titulo={"Fale conosco"}
                          onClick={() =>
                            this.props.history.push("/relacionamento")
                          }
                          tipo={TipoBotao.link}
                        />
                      </p>
                    </>
                  )}
                </Box>
              </Col>
            </Row>
          </>
        )}
      </Page>
    );
  }
}
